import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core"
import { InitiateAndReleaseComponent } from "./container/initiate-and-release.component"
import { InitReleaseTransactionsTableComponent } from "./components/init-release-transactions-table/init-release-transactions-table.component"
import { CommonModule } from "@angular/common"
import { AccountInfoModule } from "../account-info-header/account-info.module"
import { SharedModule } from "../shared/shared.module"
import * as fromInitReleaseState from './reducers';
import { CustomErrorInitReleaseTableComponent } from "./components/custom-error-init-release-table.component/custom-error-init-release-table.component"
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { intReleaseEffects } from './Effects/init-release.effects'
import { CreateRequestModule } from "../create-request/create-request.module"
import { StandingAuthorizationsModule } from "../standing-authorizations/standing-authorizations.module"
import { InitReleaseCreateRuleSectionComponent } from "./components/init-release-create-rule-section/init-release-create-rule-section.component"
import { CustomErrorCreateRuleTableComponent } from "./components/custom-error-create-rule-table.component/custom-error-create-rule-table.component"
import { InitReleaseCreateRuleModalComponent } from "./components/init-release-create-rule-modal/init-release-create-rule-modal.component"
import { InitReleaseDeleteRuleModalComponent } from "./components/init-release-delete-rule-modal/init-release-delete-rule-modal.component"
import { ReactiveFormsModule } from "@angular/forms"
import { CustomRuleInitiateAndReleaseEffects } from "./Effects/custom-rule-initiate-and-release-effects"


const COMPONENTS = [
    InitReleaseTransactionsTableComponent,
    CustomErrorInitReleaseTableComponent,
    InitReleaseCreateRuleSectionComponent,
    CustomErrorCreateRuleTableComponent,
    InitReleaseCreateRuleModalComponent,
    InitReleaseDeleteRuleModalComponent
]

const CONTAINERS = [
    InitiateAndReleaseComponent
]

@NgModule({
    declarations: [COMPONENTS, CONTAINERS],
    imports: [
      ReactiveFormsModule,
      CommonModule,
      AccountInfoModule,
      CreateRequestModule,
      SharedModule,
      StandingAuthorizationsModule,
      StoreModule.forFeature(fromInitReleaseState.initReleaseFeatureKey,
        fromInitReleaseState.reducers),
      EffectsModule.forFeature([
        intReleaseEffects,
        CustomRuleInitiateAndReleaseEffects,
      ])
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [InitiateAndReleaseComponent]
})

export class InitiateAndReleaseModule { }
